import { AfterViewInit, forwardRef, Component, ElementRef, EventEmitter, input, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-litmus-multiselect-dropdown',
  templateUrl: './litmus-multiselect-dropdown.component.html',
  styleUrl: './litmus-multiselect-dropdown.component.scss',
  imports:[NgIf,NgFor],
  standalone:true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LitmusMultiselectDropdownComponent),
      multi: true
    }
  ]
})
export class LitmusMultiselectDropdownComponent implements OnChanges, ControlValueAccessor {
  @ViewChild('litmscustomdropdown') litmscustomdropdown!: ElementRef;
  @Input() options: any = []
  @Input() settings: any = {} 
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Output() change: any = new EventEmitter<any>()
  @Output() onSelect: any = new EventEmitter<any>()
  @Output() onDeSelect: any = new EventEmitter<any>()
  @Output() onSelectAll: any = new EventEmitter<any>()
  @Output() onDeSelectAll: any = new EventEmitter<any>()

  selectedItems: any = []
  dropdownSettings: any = {};
  dropdownOptions: any = []

  isOpen = false;
  groupBy: string = ''
  preffix: string = ''
  uniqueIdField: string = 'id';
  textField: string = 'text'
  categorization: boolean = false
  list: any[] = []
  sourceList: any = []
  placeholder: string = "Select one";
  ddButton: any;
  ddMenu: any;
  listner: any;
  selectedItemIds: any = []




  val: any = []
  onChange: any = () => {}
  onTouch: any = () => {}
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options']) {
      this.dropdownOptions = this.options
    }
    if (changes['settings']) {
      this.dropdownSettings = this.settings

    }
    this.initOptions(this.dropdownSettings)
  }

  set value(val) {
    if (val !== undefined && this.val !== val) {
      // console.log(val,'///////////////')
      this.selectedItems = (val)?val:[];
      this.updateSlections()
    }

  }

  writeValue(value: any) {
    this.value = value
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', (event) => {
      if (this.litmscustomdropdown && this.litmscustomdropdown.nativeElement !== event.target && !this.litmscustomdropdown.nativeElement.contains(event.target)) {
        this.isOpen = false
      }
    });
  }

  initOptions(config: any) {
    this.groupBy = _.get(config, 'groupBy', '');
    this.preffix = _.get(config, 'preffix', '');
    this.categorization = _.get(config, 'categorization', false);
    this.placeholder = _.get(config, 'placeholder', this.placeholder);
    this.textField = _.get(config, 'textField', 'text');
    this.uniqueIdField = _.get(config, 'uniqueIdField', 'id');
    this.dropdownOptions = this.options;
    if (this.dropdownOptions.length > 0) {
      if (this.categorization) {
        this.list = this.prepareOptionsByCategory(this.dropdownOptions, this.groupBy);
        this.sourceList = Helpers.deepClone(this.list);
      } else {
        this.list = this.dropdownOptions;
        this.sourceList = Helpers.deepClone(this.dropdownOptions);
      }
    }
  }

  prepareOptionsByCategory(list: any, field: string) {
    const temp_list = _.groupBy(list, field)
    let categoriesed_list: any[] = []
    _.each(temp_list, (value: any, key: string) => {
      categoriesed_list.push({
        category_name: key.charAt(0).toUpperCase() + key.slice(1),
        options: _.filter(value, (object: any) => {
          if (!_.isEmpty(object[this.textField])) {
            return object
          }

        })
      })
    })
    return categoriesed_list
  }

  openDropDown(event: any) {
    event.preventDefault()
    this.isOpen = true;
    // setTimeout(() => {
    //   document.getElementById("litmus-dropdown-search")?.focus()
    // }, 0);
  }

  filterList(event: any) {
    event.stopPropagation();
    const text = _.get(event, 'target.value', '').toLowerCase();
    if (text && text != "") {
      if (this.categorization) {
        this.list = _.filter(Helpers.deepClone(this.sourceList), (category: any) => {
          category.options = _.filter(category.options, (option: any) => {
            return (option[this.textField] && option[this.textField].toLowerCase().indexOf(text) >= 0)
          })
          if (category.options && category.options.length) {
            return true
          } else {
            return false
          }
        })
      } else {
        this.list = _.filter(Helpers.deepClone(this.sourceList), (option: any) => {
          return (option[this.textField] && option[this.textField].toLowerCase().indexOf(text) >= 0)
        })
      }
    } else {
      this.list = Helpers.deepClone(this.sourceList)
    }
  }

  selectOption(event: any, option: any) {
    event.stopPropagation()
    if (!this.selectedItemIds.includes(option[this.uniqueIdField])) {
      this.selectedItems.push(option);
      this.onSelect.emit(this.selectedItems);
      this.change.emit(this.selectedItems)
    } else {
      this.selectedItems = _.filter(this.selectedItems, (opt) => {
        return option[this.uniqueIdField] != opt[this.uniqueIdField]
      })

      this.onDeSelect.emit(this.selectedItems);
      this.change.emit(this.selectedItems)
    }
    this.value = this.selectedItems
    this.updateSlections()
  }


  updateSlections() {
    this.selectedItemIds = _.map(this.selectedItems, (item) => {
      return item[this.uniqueIdField];
    })
  }

}
